import { UserDto } from '@web-portal/domains/shared/domain-models';
import { User } from '../entities/user.entity';

export class UserBuilder {
  private readonly user: User;

  constructor() {
    this.user = new User();
  }

  withEmail(email: UserDto['email']): this {
    this.user.email = email;
    return this;
  }

  withFirstName(firstName: UserDto['given_name']): this {
    this.user.firstName = firstName;
    return this;
  }

  withLastName(lastName: UserDto['family_name']): this {
    this.user.lastName = lastName;
    return this;
  }

  withInitials(initials?: string): this {
    this.user.initials = initials ?? this.generateInitials();
    return this;
  }

  build(): User {
    return this.user;
  }

  private generateInitials(): string {
    const firstInitial = this.user.firstName.charAt(0).toUpperCase();
    const lastInitial = this.user.lastName.charAt(0).toUpperCase();
    return `${firstInitial}${lastInitial}`;
  }
}
